import { createAsyncActionTypes } from '@mews/framework';
import { prefix } from '../module';

export const CATEGORY_ADDED = prefix('CATEGORY_ADDED');
export const CATEGORY_EDITED = prefix('CATEGORY_EDITED');
export const CATEGORY_DELETED = prefix('CATEGORY_DELETED');
export const CATEGORY_ORDERING_CHANGED = prefix('CATEGORY_ORDERING_CHANGED');

export const FLOOR_ADDED = prefix('FLOOR_ADDED');
export const FLOOR_EDITED = prefix('FLOOR_EDITED');
export const FLOOR_DELETED = prefix('FLOOR_DELETED');

export const SETTINGS_ADDED = prefix('SETTINGS_ADDED');

export const RESOURCE_SELECTED = prefix('RESOURCE_SELECTED');
export const RESOURCE_DESELECTED = prefix('RESOURCE_DESELECTED');
export const RESOURCES_DESELECTED = prefix('RESOURCES_DESELECTED');
export const RESOURCES_DELETED = prefix('RESOURCES_DELETED');
export const RESOURCES_UPDATED = prefix('RESOURCES_UPDATED');

export const CATEGORY_SELECTED = prefix('CATEGORY_SELECTED');
export const FLOOR_SELECTED = prefix('FLOOR_SELECTED');

export const STEP_CHANGED = prefix('STEP_CHANGED');

export const REDUCERS_RESET = prefix('REDUCERS_RESET');

export const JSON_DOWNLOAD_STARTED = prefix('JSON_DOWNLOAD_STARTED');

export const JSON_IMPORTED = prefix('JSON_IMPORTED');

export const IMPORT_SCHEDULE = prefix('IMPORT_SCHEDULE');
export const [IMPORT_SCHEDULE_STARTED, IMPORT_SCHEDULE_SUCCEEDED, IMPORT_SCHEDULE_FAILED] =
    createAsyncActionTypes(IMPORT_SCHEDULE);
